{
  "account": {
    "backoffice": "Administrēšana",
    "changeEmail": "Mainīt e-pastu",
    "changePassword": "Mainīt paroli",
    "confirmNewPassword": "Apstiprināt jauno paroli",
    "currentPassword": "Pašreizējā parole",
    "deliveryMethods": "Piegādes veidi",
    "deliveryMethodsDesc": "Kā vēlaties saņemt paziņojumus?",
    "email": "E-pasts",
    "emailCannotBeEmpty": "E-pasta lauks nevar būt tukšs.",
    "failedToLoadSettings": "Neizdevās ielādēt paziņojumu iestatījumus",
    "language": "Valoda",
    "maintenanceReminders": "Apkopes atgādinājumi",
    "maintenanceRemindersDesc": "Saņemt paziņojumus par gaidāmajiem apkopes darbiem",
    "mobileApp": "Mobilā lietotne",
    "myConnections": "Mani savienojumi",
    "newEmail": "Jauns e-pasts",
    "newPassword": "Jauna parole",
    "notificationPreferences": "Paziņojumu iestatījumi",
    "notificationSettingsError": "Neizdevās saglabāt paziņojumu iestatījumus",
    "notificationSettingsSaved": "Paziņojumu iestatījumi saglabāti.",
    "notificationTypes": "Paziņojumu veidi",
    "passwordsNotSame": "Jaunā parole un apstiprinājums nesakrīt.",
    "successfulEmailChange": "Pārbaudiet savu iesūtni, lai apstiprinātu e-pasta maiņu.",
    "successfulPasswordChange": "Parole veiksmīgi nomainīta.",
    "warrantyMessages": "Jaunas garantijas ziņas",
    "warrantyMessagesDesc": "Paziņojumi, kad garantijas sniedzēji atbild uz jūsu pieprasījumu"
  },
  "analytics": {
    "askQuestion": "Uzdodiet jautājumu par saviem datiem...",
    "clearChat": "Notīrīt tērzēšanu",
    "loadingSavedChat": "Notiek saglabātās tērzēšanas ielāde...",
    "stop": "Apturēt",
    "title": "Analītika",
    "tryAsking": "Mēģiniet pajautāt:"
  },
  "building": {
    "analytics": "Analītika",
    "customWarrantyNotificationEmailTemplate": "Pielāgota garantijas paziņojuma e-pasta veidne",
    "exposeSubmitterEmailInHausing": "Rādīt iesniedzēja e-pastu Hausing",
    "fileUploadMandatory": "Failu augšupielāde obligāta",
    "frontendFeatureFlags": "Lietotāja saskarnes funkciju atzīmes",
    "hausingBuildingId": "Hausing ēkas ID",
    "hausingClientId": "Hausing klienta ID",
    "hausingClientSecret": "Hausing klienta noslēpums",
    "hausingCompanyId": "Hausing uzņēmuma ID",
    "hausingMessageSyncDisabled": "Hausing ziņojumu sinhronizācija ir atspējota",
    "hausingOptOut": "Hausing atteikšanās (izlaist Hausing prasību šai ēkai)",
    "hausingSyncDisabled": "Hausing sinhronizācija atspējota",
    "hausingTicketDescription": "Hausing pieteikuma apraksts",
    "hausingTicketTitle": "Hausing pieteikuma nosaukums",
    "householdImagesPattern": "Mājokļa attēlu paraugs",
    "lookerReport": "Looker pārskats",
    "lookerReportLink": "Looker pārskata saite",
    "options": "Iespējas",
    "propertyManagerCaseRules": "Pārvaldnieka gadījumu noteikumi",
    "questionsPrompt": "Jautājumu uzvedne",
    "settings": "Ēkas iestatījumi",
    "voiceWarrantyPrompt": "Balss garantijas uzvedne",
    "warrantyAutoReplyMessage": "Garantijas automātiskās atbildes ziņojums",
    "warrantyDisabledMessage": "Ziņojums kad garantijas iesniegšana ir atspējota",
    "warrantyEmailUserList": "Garantijas e-pasta lietotāju saraksts",
    "warrantyRules": "Garantijas noteikumi",
    "warrantySyncEmail": "Garantijas sinhronizācijas e-pasts",
    "welcomeEmail": "Apsveikuma e-pasts jaunajiem lietotājiem"
  },
  "buildingSettings": {
    "accesses": "Ekspluatācijas pārvaldnieki",
    "addNewAccess": "Pievienot jaunu ēkas administratoru",
    "ai": {
      "saveError": "Neizdevās saglabāt AI konfigurāciju",
      "saveSuccess": "AI konfigurācija veiksmīgi saglabāta"
    },
    "aiSettings": "AI konfigurācija",
    "analyticsSettings": "Analītika",
    "chatPresetQuestions": "Tērzēšanas iepriekš iestatīti jautājumi",
    "emailForwarding": "E-pasta pārsūtīšana",
    "employeeSettings": "DoBu darbinieka iestatījumi",
    "enableInternalAnalytics": "Iespējot iekšējo analītiku",
    "fieldSaveError": "Neizdevās saglabāt",
    "hausing": {
      "clientSecretNotStored": "Klienta noslēpums nav saglabāts. Ievadiet to pirms savienojuma iespējošanas.",
      "clientSecretReplace": "Ievadiet jaunu noslēpumu, lai aizstātu saglabāto",
      "clientSecretRequired": "Ievadiet Hausing klienta noslēpumu",
      "clientSecretStored": "Klienta noslēpums ir saglabāts. Atstājiet lauku tukšu, lai to nemainītu.",
      "connectionConfigured": "Hausing savienojums ir iestatīts.",
      "connectionNotConfigured": "Hausing savienojums nav iestatīts.",
      "loadError": "Neizdevās ielādēt Hausing iestatījumus",
      "noFlats": "Nav pieejamu dzīvokļu.",
      "noRoom": "Nav Hausing telpas",
      "roomMappings": "Dzīvokļu sasaiste ar telpām",
      "roomMappingsHelp": "Sasaistiet katru DoBu dzīvokli ar tā Hausing telpu.",
      "roomMappingsUnavailable": "Pirms dzīvokļu sasaistes saglabājiet Hausing savienojumu.",
      "roomSaveError": "Neizdevās saglabāt dzīvokļa sasaisti ar telpu",
      "roomsLoadError": "Neizdevās ielādēt Hausing telpas. Pārbaudiet savienojuma iestatījumus.",
      "roomsLoading": "Notiek Hausing telpu ielāde...",
      "saveError": "Neizdevās saglabāt dažus Hausing iestatījumus",
      "saveSuccess": "Hausing iestatījumi veiksmīgi saglabāti"
    },
    "hausingSettings": "Hausing",
    "homeownersDashboard": {
      "accountCount": "({{count}} konti kopā)",
      "actions": "Darbības",
      "apartment": "Dzīvoklis",
      "close": "Aizvērt",
      "confirmRemove": "Noņemt",
      "confirmRemoveMessage": "Noņemt {{name}} no {{apartment}}?",
      "confirmRemoveTitle": "Noņemt īpašnieku",
      "homeowners": "Īpašnieki",
      "individual": "Persona",
      "loadError": "Neizdevās ielādēt dzīvokļu īpašniekus.",
      "manage": "Pārvaldīt",
      "noHomeowners": "Nav piesaistītu īpašnieku",
      "noResults": "Nav atrasts neviens atbilstošs dzīvoklis",
      "organization": "Uzņēmums",
      "passwordResetEmailFailed": "Neizdevās nosūtīt paroles atiestatīšanas e-pastu. Lūdzu mēģiniet vēlreiz.",
      "passwordResetEmailSent": "Paroles atiestatīšanas e-pasts nosūtīts uz {{email}}.",
      "removeError": "Neizdevās noņemt īpašnieku. Lūdzu, mēģiniet vēlreiz.",
      "removeOwner": "Noņemt",
      "removeOwnerLabel": "Noņemt {{name}} no {{apartment}}",
      "resetPassword": "Atiestatīt paroli",
      "searchPlaceholder": "Meklēt dzīvokļus vai īpašniekus",
      "sendPasswordResetEmailLabel": "Nosūtīt paroles atiestatīšanas e-pastu uz {{email}}",
      "summary": "{{householdsWithOwners}} / {{householdsCount}} dzīvokļiem ir piesaistīti īpašnieki",
      "title": "Dzīvokļu īpašnieki"
    },
    "householdSettings": "Dzīvokļu iestatījumi",
    "lookerReportLink": "Looker pārskata saite",
    "questionsForwarding": {
      "addRule": "Pievienot kārtulu",
      "allowForwarding": "Atļaut jautājumu pārsūtīšanu?",
      "description": "Aprakstiet problēmas, kuras jāpārsūta šai personai...",
      "descriptionPlaceholder": "piem., Santehnikas problēmas, Elektrības bojājumi",
      "email": "E-pasts",
      "emailInvalid": "Lietotājs nav atrasts vai nav šīs ēkas administrators.",
      "emailPlaceholder": "lietotajs@example.com",
      "name": "Kārtulas nosaukums",
      "namePlaceholder": "piem., Tehniskie jautājumi",
      "removeRule": "Noņemt kārtulu",
      "saveSuccess": "Iestatījumi veiksmīgi saglabāti",
      "title": "Mājokļa īpašnieku jautājumu pārsūtīšana"
    },
    "structuredWarrantySettings": "Paplašināta garantijas plūsma",
    "tallyForms": "Tally veidlapas",
    "title": "Būvniecības iestatījumi",
    "viewAnalytics": "Skatīt analītiku",
    "viewLookerReport": "Lietošanas analītika",
    "warranty": {
      "saveError": "Dažus garantijas iestatījumus neizdevās saglabāt",
      "saveSuccess": "Garantijas iestatījumi veiksmīgi saglabāti"
    },
    "warrantySettings": "Garantija"
  },
  "case": {
    "addReplyPromptBody": "Pievienojiet atbildi, lai turpinātu sarunu. Gadījums paliek slēgts.",
    "addReplyPromptTitle": "Pievienot atbildi",
    "awaitingReply": "Gaida atbildi",
    "closeFollowUp": "Atbilde nav vajadzīga",
    "closedByService": "Gadījumu ir slēdzis pēcpārdošanas serviss",
    "closedCantMessage": "Šis gadījums ir slēgts.",
    "closedFollowUpBanner": "Iedzīvotājs rakstīja pēc gadījuma slēgšanas. Atbildiet vai atzīmējiet, ka atbilde nav vajadzīga. Abos variantos gadījums paliek slēgts.",
    "completedCases": "Slēgti",
    "markedAsSolved": "Gadījums ir atzīmēts kā atrisināts",
    "messageWithImage": "Ziņojums ar attēlu",
    "noCases": "Jums nav reģistrētu gadījumu",
    "notFound": "Gadījums nav atrasts",
    "ongoingCases": "Notiekošie",
    "previousChatWithBot": "Iepriekšējā tērzēšana ar tērzēšanas robotu",
    "reopenPromptBody": "Atveriet šo gadījumu atkārtoti, lai turpinātu sarunu ar pēcpārdošanas servisu. Nav nepieciešams sākt jaunu.",
    "reopenPromptTitle": "Vai problēma joprojām nav atrisināta?",
    "replyWillReopen": "Ziņojuma nosūtīšana atvērs šo gadījumu atkārtoti.",
    "replyWillStayClosed": "Ziņojuma nosūtīšana paziņos servisa komandai. Gadījums paliek slēgts.",
    "submittedCases": "Iesniegtie gadījumi"
  },
  "casePage": {
    "backHome": "Atpakaļ uz sākumu",
    "notFound": "Šo gadījumu nevarēja atvērt. Saite var būt nepareiza, vai jums nav piekļuves."
  },
  "chat": {
    "videoAttachment": "Video pielikums",
    "askFailed": "Neizdevās saņemt atbildi. Pārbaudiet savienojumu un mēģiniet vēlreiz.",
    "tryAgain": "Mēģināt vēlreiz",
    "enterQuestion": "Ievadiet jautājumu",
    "escalateNo": "Nē",
    "escalateNoReply": "Labi, jautājumu nepārsūtīšu. Droši jautājiet vēl ko par savu mājokli.",
    "escalateYes": "Jā",
    "escalationForm": {
      "back": "Atpakaļ",
      "backToForm": "Atpakaļ uz veidlapu",
      "recipient": "Saņēmējs",
      "send": "Sūtīt",
      "sendErrorMessage": "Nosūtot ziņojumu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
      "sendSuccessMessage": "Jūsu ziņojums ir veiksmīgi nosūtīts.",
      "sending": "Sūta...",
      "summary": "Jūsu problēmas kopsavilkums",
      "summaryEditable": "Jūs varat rediģēt šo kopsavilkumu pirms nosūtīšanas.",
      "title": "Tēma"
    },
    "escalationFailed": "Neizdevās pārsūtīt jautājumu. Mēģiniet vēlreiz.",
    "escalationInProgress": "Analizējam jūsu pieprasījumu, lai savienotu jūs ar piemērotu ekspertu. Tas var aizņemt brīdi...",
    "longConversationWarning": "AI veiktspēja var pasliktināties garās sarunās. Apsveriet iespēju sākt jaunu sarunu, ja tēma ir mainījusies.",
    "pin1": "Durvis čīkst.",
    "pin2": "Kādā krāsā ir mana siena?",
    "pin3": "Kā lietot termostatu?",
    "question1": "Ar ko es varētu notīrīt sienu?",
    "question2": "Durvis krakšķ.",
    "question3": "No vannasistabas sifona nāk nepatīkama smaka.",
    "question4": "Kādas flīzes ir manā gaitenī?",
    "searchingDocuments": "Meklēju atbildi jūsu mājokļa dokumentos",
    "send": "Sūtīt",
    "talkToYourHome": "Runājiet ar savu māju",
    "warrantyCta": {
      "primary": "Iesniegt garantijas pieteikumu",
      "supporting": "Izskatās pēc garantijas jautājuma. Turpiniet garantijas plūsmā."
    }
  },
  "chatPresetSettings": {
    "addPreset": "Pievienot valodas iepriekšējo izvēli",
    "enable": "Iespējot pielāgotas tērzēšanas iepriekšējās izvēles",
    "errors": {
      "invalidLanguage": "Valodai jābūt divu burtu kodam (piem. 'en')",
      "noQuestions": "Katrai valodas iepriekšējai izvēlei jābūt vismaz vienam jautājumam"
    },
    "language": "Valoda ISO 639-1 (piem. en et lv)",
    "questionPlaceholder": "Jautājums {{number}}",
    "questions": "Iepriekš iestatīti jautājumi",
    "removePreset": "Noņemt iepriekšējo izvēli",
    "success": {
      "saved": "Tērzēšanas iepriekšējo izvēļu iestatījumi veiksmīgi saglabāti"
    }
  },
  "common": {
    "cancel": "Atcelt",
    "error": {
      "400": "Daļa informācijas nav derīga. Pārbaudiet to un mēģiniet vēlreiz.",
      "401": "Jūsu sesija ir beigusies. Lūdzu, piesakieties vēlreiz.",
      "403": "Jums nav atļaujas to darīt.",
      "404": "Meklētais netika atrasts. Iespējams, tas ir noņemts.",
      "409": "Tas ir pretrunā ar esošajiem datiem. Atsvaidziniet lapu un mēģiniet vēlreiz.",
      "413": "Fails ir pārāk liels.",
      "500": "Radās kļūda. Lūdzu, mēģiniet vēlreiz vēlāk.",
      "loading": "Neizdevās ielādēt lapu. Lūdzu, atsvaidziniet to.",
      "network": "Nav savienojuma. Pārbaudiet interneta savienojumu un mēģiniet vēlreiz."
    },
    "intervalDays": "{{count}} dienas",
    "loading": "Notiek ielāde...",
    "loadingData": "Ielādē...",
    "returnToHome": "Atgriezties sākumlapile",
    "saveChanges": "Saglabāt izmaiņas",
    "saving": "Saglabā...",
    "tryAgain": "Mēģināt vēlreiz",
    "validating": "Notiek pārbaude..."
  },
  "files": {
    "addFiles": "Pievienot dokumentus",
    "addFilesInstructions": "<span1>Velciet</span1> dokumentus šeit vai <span2>noklikšķiniet</span2>, lai atlasītu manuāli.",
    "confirmDeleteBody": "Vai tiešām vēlaties dzēst izvēlēto dokumentu?",
    "confirmDeleteNo": "Atgriezties",
    "confirmDeleteTitle": "Dzēst dokumentu",
    "confirmDeleteYes": "Dzēst",
    "download": "Lejupielādēt",
    "loadingPreview": "Notiek dokumenta priekšskatījuma ielāde...",
    "officePreviewHint": "Dokuments netiek parādīts?",
    "openInNewTab": "Atvērt jaunā cilnē",
    "previewError": {
      "message": "Neizdevās parādīt šī dokumenta priekšskatījumu. Fails joprojām ir pieejams un to var atvērt ar atbilstošu programmu.",
      "title": "Priekšskatījums nav pieejams"
    },
    "remove": "Dzēst",
    "save": "Saglabāt",
    "stillLoading": "Ielāde vēl turpinās. Liela faila atvēršana var aizņemt līdz minūtei.",
    "successfullyUploaded": "Faili veiksmīgi augšupielādēti.",
    "uploading": "Augšupielādē failus..."
  },
  "home": {
    "myResidences": "Mani īpašumi",
    "welcome": "Laipni lūdzam!"
  },
  "household": {
    "actions": "Darbības",
    "documents": "Dokumenti",
    "exterior": "Āra zona",
    "floor": "stāvs",
    "maintenanceActivities": "Manas apkopes aktivitātes",
    "maintenanceInfo": "Visa nepieciešamā apkope, kas jāveic mājas īpašniekam, ir aprakstīta attiecīgajās instrukcijās.",
    "mobileApp": {
      "appLink": "Lejupielādēt šeit",
      "message": "DoBu izlaida mobilo lietotni:"
    },
    "products": "produkti",
    "productsWithoutRoom": "Produkti bez telpas",
    "propertyManagerCases": "Pārvaldnieka gadījumi",
    "roomsAndProducts": "Telpas un produkti",
    "warrantyCases": "Garantijas gadījumi"
  },
  "loggedInPage": {
    "tallyFormBanner": {
      "button": "Aizpildīt veidlapu"
    }
  },
  "login": {
    "aboutInfo": "DoBu pašlaik ir pieejams tikai māju īpašniekiem nekustamo īpašumu attīstības projektos, kas izmanto mūsu pakalpojumus.",
    "alreadyHaveAccount": "Jau ir <strong>DoBu</strong> konts?",
    "confirm": "Apstiprināt",
    "confirmEmailChange": "Apstiprināt e-pasta maiņu",
    "confirmNewPassword": "Apstiprināt jauno paroli",
    "confirmPassword": "Apstiprināt paroli",
    "continue": "Turpināt",
    "email": "E-pasts",
    "emailChangeSuccessful": "E-pasta maiņa veiksmīga. Jaunais e-pasts ir {{newEmail}}. Lūdzu, piesakieties, izmantojot jauno e-pastu.",
    "error": {
      "invalidOldPassword": "Nepareiza vecā parole.",
      "notAuthorized": "Nav autorizēts.",
      "privateRelayNotAllowed": "Pieteikšanās ar Apple nav iespējama, ja lietojat “Slēpt manu e-pastu”. Lūdzu, piesakieties, izmantojot citu metodi, vai izdzēsiet savu DoBu kontu no saviem Apple ID iestatījumiem un mēģiniet vēlreiz.",
      "socialUserNotRegistered": "Ar sociālo pieteikšanos saistītais e-pasts nav reģistrēts. Lūdzu, pārbaudiet, kuru e-pasta adresi izmantojāt reģistrējoties, un mēģiniet vēlreiz.",
      "tokenExpired": "URL jau ir izmantots vai tam ir beidzies derīguma termiņš.",
      "userNotFound": "Konts nav atrasts. Šī ir pārvaldīta lietojumprogramma. Lūdzu, sazinieties ar savas ēkas administratoru, lai iestatītu savu kontu."
    },
    "forgotPassword": "Aizmirsāt paroli?",
    "login": "Pieteikties",
    "loginError": "Lietotājs nav atrasts vai parole ir nepareiza.",
    "logout": "Izrakstīties",
    "newEmail": "Jauns e-pasts",
    "newPassword": "Jauna parole",
    "noAccount": "Nav <strong>DoBu</strong> konta?",
    "noAccountHeader": "Nav DoBu konta?",
    "noAccountYet": "Vēl nav konta? Jūsu attīstītājam vai pārvaldniekam vispirms jāpievieno jūs jūsu mājoklim DoBu. Pēc tam saņemsiet e-pastu paroles izveidei.",
    "or": "vai",
    "password": "Parole",
    "passwordResetInstructions": "Ievadiet sava DoBu konta e-pastu, un mēs nosūtīsim saiti jaunas paroles iestatīšanai.",
    "privacyPolicy": "Privātuma politika",
    "recoveryFormNotValid": "Atkopšanas veidlapa nav derīga.",
    "resetPassword": "Nosūtīt saiti",
    "resetPasswordFormSuccess": "Ja šim e-pastam ir DoBu konts, esam uz to nosūtījuši saiti jaunas paroles iestatīšanai. Pārbaudiet arī surogātpasta mapi.",
    "stuckHelp": "Neizdodas pieteikties? Izmantojiet e-pasta adresi, uz kuru DoBu jums nosūtīja pirmo vēstuli, vai rakstiet mums: <mail>info@dobu.app</mail>.",
    "resetPasswordSuccess": "Parole atjaunināta. Varat pieteikties ar jauno paroli.",
    "seeMore": "Skatīt vairāk",
    "wantToTry": "Ja joprojām vēlaties izmēģināt DoBu, rakstiet mums:"
  },
  "notifications": {
    "alreadyUnsubscribed": "Jau atteikts {{date}}",
    "confirmUnsubscribe": "Apstiprināt atteikšanos",
    "confirmUnsubscribeMessage": "Vai tiešām vēlaties atteikties no paziņojumu saņemšanas? Jūs vienmēr varat tos atkārtoti aktivizēt sava konta iestatījumos.",
    "invalidUnsubscribeToken": "Nederīga vai beidzies atteikšanās saites derīguma termiņš",
    "unsubscribeConfirm": "Jā, atteikties no paziņojumiem",
    "unsubscribeDescription": "Jūs gatavojaties atteikties no visiem paziņojumiem.",
    "unsubscribeErrorGeneric": "Radās kļūda, veicot atteikšanos",
    "unsubscribeSuccess": "Veiksmīgi atteikts",
    "unsubscribeSuccessDetail": "Jūs vairs nesaņemsiet paziņojumus no mums.",
    "unsubscribeTitle": "Atteikties no paziņojumiem",
    "unsubscribing": "Atteikšanās no paziņojumiem..."
  },
  "product": {
    "addDocuments": "Pievienot dokumentus",
    "addNewProduct": "Pievienot jaunu produktu",
    "addProduct": "Pievienot produktu",
    "addProductFiles": "Pievienot failus",
    "change": "Mainīt",
    "changeProduct": "Mainīt produktu",
    "confirmMaintenanceDone": "Veikta apkope",
    "delete": "Dzēst",
    "everyNumberOfDays": "Ik pēc {{interval}} dienām",
    "extraInfo": "Papildinformācija",
    "extraInfoAboutTheProduct": "Papildinformācija par produktu",
    "maintenanceHistory": "Tehniskās apkopes vēsture",
    "maintenanceInfo": "Informācija par apkopi",
    "maintenanceInterval": "Apkopes intervāls (dienās)",
    "maintenanceName": "Apkopes nosaukums",
    "maintenanceOverview": {
      "addFileTooltip": "Obligāti",
      "date": "Apkope veikta",
      "document": "Faili",
      "scheduledDate": "Termiņš"
    },
    "maintenancePopup": {
      "addFile": "Pievienot failu",
      "addFileTooltip": "Pievienot failu",
      "done": "Gatavs",
      "maintenanceGuide": "Apkopes rokasgrāmata",
      "maintenanceInterval": "Apkopes intervāls",
      "relatedProduct": "Saistītais produkts",
      "upcomingMaintenance": "Gaidāmā apkope"
    },
    "manufacturer": "Ražotājs",
    "name": "Produkta nosaukums",
    "nextMaintenance": "Nākamā apkope",
    "productNumber": "Produkta numurs",
    "productSuccessfullyChanged": "Produkts veiksmīgi mainīts.",
    "relatedDocuments": "Saistītie dokumenti",
    "relatedRooms": "Saistītās telpas",
    "saveChanges": "Saglabāt izmaiņas"
  },
  "propertyManagerCase": {
    "addFiles": "Pievienot failus",
    "afterSalesService": "Pēcpārdošanas serviss",
    "answer": "Atbildēt",
    "cancel": "Atcelt",
    "caseActions": {
      "addReply": "Pievienot atbildi",
      "closeCase": "Aizvērt gadījumu",
      "markAsSolved": "Atzīmēt kā atrisinātu",
      "openCase": "Atvērt gadījumu",
      "reopenCase": "Atvērt gadījumu atkārtoti"
    },
    "caseDescription": "Gadījuma apraksts",
    "caseDetails": {
      "address": "Adrese",
      "category": "Kategorija",
      "name": "Vārds",
      "phoneNumber": "Tālruņa numurs",
      "subcontractor": "Pakalpojuma sniedzējs"
    },
    "caseStatus": {
      "backlog": "Pārvaldnieka pārskatīšanā",
      "closed": "Noraidīts",
      "inProgress": "Procesā",
      "notDone": "Atvērts",
      "review": "Pārskatīšanā",
      "solved": "Pabeigts",
      "status": "Statuss",
      "toDo": "Apstiprināšanas procesā",
      "waiting": "Uz pauzes"
    },
    "caseTitle": "Gadījuma nosaukums",
    "cases": "Pārvaldnieka gadījumi",
    "completedCases": "Slēgti",
    "contactPersonsPhoneNumber": "Kontaktpersonas tālruņa numurs",
    "defectDate": "Gadījuma rašanās datums",
    "defectDescription": "Precīzs gadījuma apraksts",
    "defectLocation": "Gadījuma precīza atrašanās vieta ēkā/dzīvoklī",
    "describeCase": "Aprakstiet pārvaldnieka gadījumu",
    "descriptionIsSufficient": "Apraksts ir pietiekams",
    "downloadFile": "Lejupielādēt failu",
    "emailNotification": "Lūdzu, ņemiet vērā, ka atbildes uz jūsu ziņām tiks nosūtītas uz jūsu e-pastu. Atcerieties pārbaudīt arī mēstuļu mapi.",
    "forceSubmitCase": "Iesniegt gadījumu",
    "maintenanceOverview": {
      "addFileTooltip": "Obligāti",
      "date": "Apkope veikta",
      "document": "Faili",
      "scheduledDate": "Termiņš"
    },
    "mandatoryFile": "Pēc gadījuma apraksta sniegšanas ar AI palīdzību, ir jāpievieno fails, kas ir obligāts",
    "noCases": "Jums nav reģistrētu pārvaldnieka gadījumu",
    "noFilesUploaded": "Failu augšupielāde ir obligāta",
    "notCovered": "Iespējams, ka gadījums neietilpst pārvaldnieka pienākumos",
    "ongoingCases": "Notiekošie",
    "owner": "Īpašnieks",
    "pictureDescription": "Ātrākai gadījuma apstrādei: lūdzu, pievienojiet divus attēlus - vienu tuvplānā un otru no attāluma, lai parādītu problēmas atrašanās vietu.",
    "problemDescriptionInstructions": "Lūdzu, aprakstiet problēmu pēc iespējas precīzāk:",
    "sendMessageToDeveloper": "Sūtīt ziņu pārvaldniekam",
    "sendMessageToOwner": "Sūtīt ziņu iedzīvotājam",
    "sendingCase": "Notiek gadījuma sūtīšana...",
    "startSubmission": "Sākt iesniegšanu",
    "submitCase": "Iesniegt gadījumu",
    "submitNewCase": "Iesniegt jaunu pārvaldnieka gadījumu",
    "submitOneCase": "Iesniedziet vienu pārvaldnieka gadījumu vienlaikus",
    "submittedCases": "Iesniegtie pārvaldnieka gadījumi"
  },
  "question": {
    "ask_in_chat_hint": "Jautājumi, kurus uzdodat AI asistentam tērzēšanas laikā, tiks parādīti šeit.",
    "closedByService": "Jautājumu ir slēdzis pēcpārdošanas serviss",
    "details": {
      "address": "Adrese",
      "name": "Vārds"
    },
    "downloadFile": "Lejupielādēt failu",
    "emailNotification": "Lūdzu, ņemiet vērā, ka atbildes uz jūsu ziņām tiks nosūtītas uz jūsu e-pastu. Atcerieties pārbaudīt arī mēstuļu mapi.",
    "loading": "Ielādē jautājumus...",
    "markedAsSolved": "Jautājums ir atzīmēts kā atrisināts",
    "messageWithImage": "Ziņojums ar attēlu",
    "no_questions_yet": "Jūs vēl neesat uzdevis nevienu jautājumu.",
    "notFound": "Jautājums nav atrasts",
    "previousChatWithBot": "Iepriekšējā tērzēšana ar tērzēšanas robotu",
    "questions": "Jautājumi",
    "sendMessageToDeveloper": "Sūtīt ziņu attīstītājam",
    "sendMessageToOwner": "Sūtīt ziņu iedzīvotājam",
    "status": {
      "backlog": "Pārskatīšanā",
      "closed": "Slēgts",
      "solved": "Atrisināts",
      "status": "Statuss"
    },
    "submittedQuestions": "Iesniegtie jautājumi"
  },
  "room": {
    "add": "Pievienot telpu",
    "addNew": "Pievienot jaunu telpu",
    "change": "Mainīt telpas",
    "delete": "Dzēst",
    "floor": "Stāvs",
    "name": "Nosaukums",
    "newRoomName": "Jauns telpas nosaukums",
    "outdoor": "Ārā",
    "rename": "Pārdēvēt",
    "save": "Saglabāt"
  },
  "settings": {
    "accesses": "Piekļuves",
    "accountAssignmentFailed": "Neizdevās piešķirt kontu.",
    "addNewAccess": "Pievienot jaunu iedzīvotāju",
    "companyFirstUserEmail": "Lietotāja e-pasts",
    "companyFirstUserName": "Lietotāja vārds",
    "companyName": "Uzņēmuma nosaukums",
    "confirmUnassign": "Noņemt",
    "confirmUnassignMessage": "Vai tiešām vēlaties noņemt piekļuvi lietotājam {{name}}?",
    "confirmUnassignTitle": "Noņemt piekļuvi",
    "currentWarrantyEndDate": "Pašreizējais garantijas beigu datums",
    "email": "E-pasts",
    "emailRequired": "E-pasts ir obligāts",
    "householdSettings": "Mājsaimniecības iestatījumi",
    "individual": "Persona",
    "moreInfoRequired": "Nepieciešama papildu informācija.",
    "name": "Vārds",
    "organization": "Uzņēmums",
    "personName": "Persona vārds",
    "registryCode": "Reģistrācijas numurs",
    "registryCodeRequired": "Reģistrācijas numurs ir obligāts",
    "save": "Saglabāt",
    "saveError": "Neizdevās saglabāt konfigurāciju",
    "saveFailed": "Neizdevās saglabāt iestatījumus",
    "saveSuccess": "Iestatījumi veiksmīgi saglabāti",
    "saving": "Saglabā...",
    "title": "Konfigurēt piekļuvi",
    "type": "Tips",
    "warrantyEndDate": "Garantijas beigu datums",
    "warrantyUpdateFailed": "Neizdevās atjaunināt garantijas datumu."
  },
  "structuredWarrantySettings": {
    "addCategory": "Pievienot kategoriju",
    "addSubcontractor": "Pievienot apakšuzņēmēju",
    "categories": "Garantijas kategorijas",
    "categoryDescription": "Apraksts (AI kategorizēšanai)",
    "categoryDescriptionPlaceholder": "Palīdz AI izvēlēties pareizo kategoriju. Piem., problēmas ar apkuri, radiatoriem, termostatiem, grīdas apsildi",
    "categoryDocs": "Dokumenti",
    "categoryName": "Kategorijas nosaukums",
    "customPrompt": "Pielāgota uzvedne (neobligāti)",
    "customPromptPlaceholder": "Vada AI garantijas pieteikuma iesniegšanā šajā kategorijā. Piem., jautāt ierīces modeļa numuru un iegādes datumu",
    "defaultCategory": "Noklusējuma kategorija",
    "defaultCategoryDescription": "Apraksts (neobligāti)",
    "defaultCategoryName": "Nosaukums (neobligāti)",
    "defaultDocs": "Noklusējuma dokumenti",
    "defaultEmail": "Noklusējuma e-pasts",
    "enable": "Iespējot paplašināto garantijas plūsmu",
    "hideDocuments": "Slēpt pieejamos dokumentus",
    "noDocsSelected": "Nav atlasītu dokumentu",
    "noDocuments": "Nav pieejamu dokumentu",
    "noMatchingDocuments": "Nav atbilstošu dokumentu",
    "removeCategory": "Noņemt kategoriju",
    "removeSubcontractor": "Noņemt apakšuzņēmēju",
    "searchDocuments": "Meklēt dokumentus...",
    "showDocuments": "Rādīt pieejamos dokumentus ({{count}})",
    "subcontractorEmail": "E-pasts",
    "subcontractorName": "Nosaukums",
    "subcontractors": "Apakšuzņēmēji"
  },
  "tallyFormSettings": {
    "addForm": "Pievienot veidlapu",
    "bannerText": "Baneru teksts (piem., Laimējiet 100 €, aizpildot veidlapu!)",
    "bannerTextPlaceholder": "Ievadiet ziņu, kas mudina lietotājus aizpildīt veidlapu",
    "enable": "Iespējot Tally veidlapas",
    "errors": {
      "invalidLanguage": "Valodai jābūt divu burtu kodam (piem., \"en\"). Jūs ievadījāt: \"{{language}}\"",
      "invalidUrl": "Izmantojiet publisku Tally.so veidlapas URL. Jūs ievadījāt: \"{{url}}\"",
      "urlEndsWithEdit": "URL nedrīkst beigties ar \"/edit\". Lūdzu, norādiet publisko veidlapas URL."
    },
    "language": "Valoda ISO 639-1 (piem., en, et, lv)",
    "removeRule": "Noņemt kārtulu",
    "resetStatuses": "Atiestatīt mājokļu statusus",
    "success": {
      "reset": "Mājokļa statusi veiksmīgi atiestatīti",
      "saved": "Tally veidlapas iestatījumi veiksmīgi saglabāti"
    },
    "url": "Tally.so veidlapas URL (piem., https://tally.so/r/xyz)"
  },
  "warranty": {
    "addFiles": "Pievienot failus",
    "afterSalesService": "Pēcpārdošanas serviss",
    "answer": "Atbildēt",
    "cancel": "Atcelt",
    "caseActions": {
      "addReply": "Pievienot atbildi",
      "closeCase": "Aizvērt gadījumu",
      "markAsSolved": "Atzīmēt kā atrisinātu",
      "openCase": "Atvērt gadījumu",
      "reopenCase": "Atvērt gadījumu atkārtoti"
    },
    "caseDescription": "Gadījuma apraksts",
    "caseDetails": {
      "address": "Adrese",
      "category": "Kategorija",
      "name": "Vārds",
      "phoneNumber": "Tālruņa numurs",
      "subcontractor": "Pakalpojuma sniedzējs"
    },
    "caseStatus": {
      "backlog": "Būvnieka pārskatīšanā",
      "closed": "Noraidīts",
      "inProgress": "Procesā",
      "notDone": "Atvērts",
      "review": "Pārskatīšanā",
      "solved": "Pabeigts",
      "status": "Statuss",
      "toDo": "Apstiprināšanas procesā",
      "waiting": "Uz pauzes"
    },
    "caseTitle": "Gadījuma nosaukums",
    "cases": "Garantijas gadījumi",
    "completedCases": "Slēgti",
    "contactPersonsPhoneNumber": "Kontaktpersonas tālruņa numurs",
    "defectDate": "Defekta rašanās datums",
    "defectDescription": "Precīzs defekta apraksts",
    "defectLocation": "Defekta precīza atrašanās vieta ēkā/dzīvoklī",
    "describeCase": "Aprakstiet garantijas gadījumu",
    "description": "Apraksts",
    "descriptionIsSufficient": "Apraksts ir pietiekams.",
    "developer": "Attīstītājs",
    "downloadFile": "Lejupielādēt failu",
    "emailNotification": "Lūdzu, ņemiet vērā, ka atbildes uz jūsu ziņām tiks nosūtītas uz jūsu e-pastu. Atcerieties pārbaudīt arī mēstuļu mapi.",
    "file": "Fails",
    "filesSelected": "fails(-i) atlasīti",
    "forceSubmitCase": "Iesniegt gadījumu",
    "likelyCovered": "Šis gadījums visticamāk ir garantijas segts",
    "maintenanceOverview": {
      "addFileTooltip": "Obligāti",
      "date": "Apkope veikta",
      "document": "Faili",
      "scheduledDate": "Termiņš"
    },
    "mandatoryFile": "Pēc gadījuma apraksta sniegšanas ar AI palīdzību, ir jāpievieno fails, kas ir obligāts.",
    "mayNotBeCovered": "Šis gadījums var nebūt garantijas segts",
    "noCases": "Jums nav reģistrētu garantijas gadījumu.",
    "noFilesUploaded": "Failu augšupielāde ir obligāta.",
    "notCovered": "Iespējams, ka gadījums neietilpst garantijā.",
    "ongoingCases": "Notiekošie",
    "owner": "Īpašnieks",
    "phoneNumberPlaceholder": "+371 2222 222",
    "pictureDescription": "Ātrākai gadījuma apstrādei: lūdzu, pievienojiet divus attēlus - vienu tuvplānā un otru no attāluma, lai parādītu problēmas atrašanās vietu.",
    "problemDescriptionInstructions": "Lūdzu, aprakstiet problēmu pēc iespējas precīzāk:",
    "sendMessageToDeveloper": "Sūtīt ziņu attīstītājam",
    "sendMessageToOwner": "Sūtīt ziņu iedzīvotājam",
    "sendingCase": "Notiek gadījuma sūtīšana...",
    "startSubmission": "Sākt iesniegšanu",
    "subcontractor": "Pakalpojumu sniedzējs",
    "submissionDisabled": "Garantijas pieteikuma iesniegšana vēl nav savienota ar būvnieka sistēmu. Tas ir pagaidu risinājums. Lūdzu, pārbaudiet vēlreiz pēc dažām dienām. Steidzamu jautājumu gadījumā, lūdzu, rakstiet uz e-pastu info@dobu.app.",
    "submitCase": "Iesniegt gadījumu",
    "submitClaim": "Iesniegt pieteikumu",
    "submitNewCase": "Iesniegt jaunu garantijas gadījumu",
    "submitOneCase": "Iesniedziet vienu garantijas gadījumu vienlaikus.",
    "submittedCases": "Iesniegtie garantijas gadījumi",
    "voiceAgent": {
      "callInProgress": "Saruna notiek",
      "callWarrantyAgent": "Zvanīt garantijas aģentam",
      "connecting": "Savienojas..."
    },
    "warrantyIsValidUntil": "Garantija ir derīga līdz {{date}}.",
    "warrantyPeriodHasExpired": "Garantijas periods ir beidzies."
  },
  "warrantyInspection": {
    "defects": "Šajā apskatē konstatētie defekti",
    "needsAttention_one": "{{count}} prasa uzmanību",
    "needsAttention_other": "{{count}} prasa uzmanību",
    "needsAttention_zero": "{{count}} prasa uzmanību",
    "progress": "{{done}}/{{total}} pabeigti",
    "title": "Garantijas beigu apskate"
  },
  "warrantyIntake": {
    "builderNoteTitle": "No būvnieka garantijas nosacījumiem:",
    "nextIssue": "Nākamā no jūsu saraksta (atlikušas {{count}}). Ja vēlaties, papildiniet un sāciet iesniegšanu.",
    "otherIssuesHint": "Katrai būs atsevišķs gadījums. Pēc šī iesniegšanas turpināsim ar nākamo.",
    "otherIssuesTitle": "Jūs minējāt arī:",
    "selfCheckHint": "Ja tas nepalīdz, iesniedziet gadījumu zemāk.",
    "selfCheckTitle": "Pirms iesniegšanas varat izmēģināt šo no jūsu mājokļa instrukcijām:",
    "skipIssue": "Izlaist šo",
    "submitted": "Gadījums iesniegts.",
    "tipOneMessage": "Vienā ziņā uzrakstiet, kas nav kārtībā, kur tas atrodas un aptuveni kad to pamanījāt. Tad gadījums ir gatavs uzreiz.",
    "tipSeveral": "Vairākas problēmas? Uzskaitiet tās visas uzreiz. Katra kļūs par atsevišķu gadījumu, viena pēc otras, bez pārrakstīšanas."
  }
}
